import React, { useState, useEffect } from "react";
import { X, Camera, User, Building2, Mail, Phone, MapPin, Calendar, Shield, Eye, EyeOff } from "lucide-react";
import "./AddEmployee.css";
import { ImageUploadLoader } from "../../../../components/uxCollections/Loaders";
import { useSelector, useDispatch } from "react-redux";
import ImageCropper from "../../../../components/imageCropper/ImageCropper";
import { createEmployeeUrl, uploadEmployeeImageUrl } from "../../../../api/endpoints";
import { uploadloadOneImage } from "../../../../tools/uploadImage";
import { refreshUserToken } from "../../../../tools/refreshToken";
import { setUser } from "../../../../slice/webStoreUserSlice";
import { Navigate } from "react-router-dom";

const imagePlaceholder = "https://www.kindpng.com/picc/m/78-786207_user-avatar-png-user-avatar-icon-png-transparent.png";
export const AddEmployee = ({ isOpen, onClose, onAddEmployee }) => {
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    storeAssigned: "", // Id of the store assigned to the employee
    salary: "",
    employmentDate: "",
    gender: "",
    address: "",
    accessLevel: "staff",
    email: "",
    phone: "",
  });

  const [employeeImageUrl, setEmployeeImageUrl] = useState(null);
  const [employeeImageUrlStage, setEmployeeImageUrlStage] = useState(null); // for uploading image to cropper
  const [croppedImageBuffer, setCroppedImageBuffer] = useState(null); //
  const [openImageCropper, setOpenImageCropper] = useState(false);
  const [loading, setLoading] = useState(false); //

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [creatingEmployee, setCreatingEmployee] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.webStoreUser);
  console.log("user in add employee modal", user);

  useEffect(() => {
    if (croppedImageBuffer) {
      sendImageToBackend();
    }
  }, [croppedImageBuffer]);

  //uploading image first to backend and getting the url

  const sendImageToBackend = async () => {
    try {
      let { imageUrl } = await uploadloadOneImage("", "", uploadEmployeeImageUrl, "EmployeeImage", false, croppedImageBuffer);
      setEmployeeImageUrl(imageUrl);
    } catch (error) {
      alert("Error uploading image. Please try again.");
    } finally {
      setLoading(false);
    }
    /* setLoading(false); */
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.position.trim()) newErrors.position = "Position is required";
    if (!formData.storeAssigned.trim()) newErrors.storeAssigned = "Store assignment is required";

    if (!formData.salary || formData.salary <= 0) newErrors.salary = "Valid salary is required";
    if (!formData.employmentDate) newErrors.employmentDate = "Employment date is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.address.trim()) newErrors.address = "Address is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is invalid";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const generateCredentials = (name, employeeId) => {
    const namePart = getInitials(name).toLowerCase();
    const username = `${namePart}-${employeeId.slice(-4)}-${Math.floor(Math.random() * 1000)}`; // e.g. john-12345678-1234

    const yearStr = new Date().getFullYear().toString();
    const yearPart = yearStr.slice(-2); // Last two digits of the current year
    const monthPart = (new Date().getMonth() + 1).toString().padStart(2, "0"); // Current month, padded to 2 digits
    const dayPart = new Date().getDate().toString().padStart(2, "0"); // Current day, padded to 2 digits
    const initials = name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    const password = `${initials}#${yearPart}#${monthPart + dayPart}${employeeId.slice(-6)}`;

    return { username, password };
  };

  const generateEmployeeId = () => {
    return (
      Math.floor(Math.random() * 1000)
        .toString()
        .padStart(3, "0") + Date.now().toString().slice(-7)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Form submitted");

    if (!validateForm()) return;
    setLoading(true);

    const employeeId = generateEmployeeId();
    const { username, password } = generateCredentials(formData.name, employeeId);

    /*   let newEmployee = {
      employeeName: employeeData.employeeName,
      employeeEmail: employeeData.employeeEmail,
      employeePhoneNumber: employeeData.employeePhoneNumber,
      employeeAddress: employeeData.employeeAddress,
      storeAssignedToID: employeeData.storeAssignedToID,
      employeeImage: employeeImageUrl ? employeeImageUrl : "https://www.kindpng.com/picc/m/78-786207_user-avatar-png-user-avatar-icon-png-transparent.png",
    }; */

    const newEmployee = {
      employeeId, // generated employee ID
      employeeName: formData.name,
      employeeEmail: formData.email,
      employeUsername: username, // generated username
      employeePassword: password, // generated password
      employeeAccessLevel: formData.accessLevel, // e.g. staff, manager, admin
      employeePhoneNumber: formData.phone,
      employeeAddress: formData.address,
      position: formData.position, // position of the employee
      storeAssigned: formData.storeAssigned, //{storeID, storeName},

      dateOfEmployment: formData.employmentDate, // date of employment
      stateOfOrigin: "", // optional field, can be added later
      gender: formData.gender,
      password: password, // generated password
      employeeImage: employeeImageUrl,
      salary: parseInt(formData.salary),
    };

    console.log("Creating new employee:", newEmployee);

    try {
      setCreatingEmployee(true);
      let response = await fetch(createEmployeeUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(newEmployee),
      });
      if (response.ok) {
        let { webstoreUser, employee } = await response.json();
        //webstoreUser with employees array
        dispatch(setUser(webstoreUser));
        onAddEmployee(employee);
        alert("Employee created successfully!");

        onClose(); // Close the modal after successful creation
      } else if (response.status === 400) {
        /* send refreshToken */
        refreshUserToken(createEmployeeUrl, handleSubmit, Navigate);
      }
    } catch (error) {
      console.error("Error creating employee:", error);
      alert("Failed to create employee. Please try again.");
      return;
    } finally {
      setCreatingEmployee(false);
      // Reset form
      setFormData({
        name: "",
        position: "",
        storeAssigned: "",
        salary: "",
        employmentDate: "",
        gender: "",
        address: "",
        accessLevel: "staff",
        email: "",
        phone: "",
      });
      setErrors({});
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    console.log("Overlay clicked, closing modal");
    onClose();
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Close button clicked");
    onClose();
  };

  if (!isOpen) {
    console.log("Modal is closed, not rendering");
    return null;
  }

  console.log("Modal is open, rendering content");

  const handleUpload = async (e) => {
    try {
      setLoading(true);
      let imageBuffer = e.target.files[0];
      if (imageBuffer) {
        const reader = new FileReader();
        reader.onload = function (evt) {
          setEmployeeImageUrlStage(evt.target.result);
          setOpenImageCropper(true);
        };
        reader.readAsDataURL(imageBuffer);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='add-emp-overlay' onClick={handleOverlayClick}></div>
      <div className='add-emp-modal' onClick={handleModalClick}>
        <div className='add-emp-header'>
          <h2 className='add-emp-title'>Add New Employee</h2>
          <button className='add-emp-close-btn' type='button' onClick={handleCloseClick}>
            <X className='add-emp-close-icon' />
          </button>
        </div>

        <form className='add-emp-form' onSubmit={handleSubmit}>
          <div className='add-emp-form-grid'>
            {/* Basic Information Section */}
            <div className='add-emp-section'>
              {/* text img */}
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
                <div className='eImageWrpa'>
                  {!loading && (
                    <>
                      <img
                        style={{ borderRadius: "100%", border: "1px solid #e7e7e7" }}
                        src={employeeImageUrl ? employeeImageUrl : imagePlaceholder}
                        alt='image'
                      />
                      <input onChange={(e) => handleUpload(e)} type={"file"} accept='image/*' className='inputSelectImage' style={{ zIndex: "2000" }} />
                      <Camera
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          left: 0,
                          bottom: 0,
                          margin: "auto",
                        }}
                        color='gray'
                      />
                    </>
                  )}

                  {loading && (
                    <div style={{ borderRadius: "100%" }} id='ImageLoading'>
                      {" "}
                      <ImageUploadLoader />{" "}
                    </div>
                  )}
                </div>
              </div>

              <h3 className='add-emp-section-title'>
                <User className='add-emp-section-icon' />
                Basic Information
              </h3>

              <div className='add-emp-field-group'>
                <div className='add-emp-field'>
                  <label className='add-emp-label'>Full Name *</label>
                  <input
                    type='text'
                    name='name'
                    value={formData.name}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.name ? "add-emp-input-error" : ""}`}
                    placeholder='Enter full name'
                  />
                  {errors.name && <span className='add-emp-error'>{errors.name}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Position *</label>
                  <input
                    type='text'
                    name='position'
                    value={formData.position}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.position ? "add-emp-input-error" : ""}`}
                    placeholder='e.g. Sales Associate, Manager'
                  />
                  {errors.position && <span className='add-emp-error'>{errors.position}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Store Assignment *</label>
                  <select
                    name='storeAssigned'
                    value={formData.storeAssigned}
                    onChange={handleInputChange}
                    className={`add-emp-select ${errors.storeAssigned ? "add-emp-input-error" : ""}`}
                  >
                    <option value='' disabled selected hidden>
                      Select a store
                    </option>
                    {user.store.map((store) => (
                      <option value={store._id}>{store.storeName}</option>
                    ))}
                  </select>
                  {errors.storeAssigned && <span className='add-emp-error'>{errors.storeAssigned}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Access Level *</label>
                  <select name='accessLevel' value={formData.accessLevel} onChange={handleInputChange} className='add-emp-select'>
                    <option value='staff'>Staff</option>
                    <option value='manager'>Manager</option>
                    <option value='admin'>Admin</option>
                  </select>
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Salary ({user.userCountryCurrencySymbol}) *</label>
                  <input
                    type='number'
                    name='salary'
                    value={formData.salary}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.salary ? "add-emp-input-error" : ""}`}
                    placeholder='e.g. 35000'
                    min='0'
                  />
                  {errors.salary && <span className='add-emp-error'>{errors.salary}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Employment Date *</label>
                  <input
                    type='date'
                    name='employmentDate'
                    value={formData.employmentDate}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.employmentDate ? "add-emp-input-error" : ""}`}
                  />
                  {errors.employmentDate && <span className='add-emp-error'>{errors.employmentDate}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Gender *</label>
                  <select
                    name='gender'
                    value={formData.gender}
                    onChange={handleInputChange}
                    className={`add-emp-select ${errors.gender ? "add-emp-input-error" : ""}`}
                  >
                    <option value=''>Select gender</option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Other'>Other</option>
                  </select>
                  {errors.gender && <span className='add-emp-error'>{errors.gender}</span>}
                </div>

                <div className='add-emp-field add-emp-field-full'>
                  <label className='add-emp-label'>Address *</label>
                  <textarea
                    name='address'
                    value={formData.address}
                    onChange={handleInputChange}
                    className={`add-emp-textarea ${errors.address ? "add-emp-input-error" : ""}`}
                    placeholder='Enter full address'
                    rows='3'
                  />
                  {errors.address && <span className='add-emp-error'>{errors.address}</span>}
                </div>
              </div>
            </div>

            {/* Contact Information Section */}
            <div className='add-emp-section'>
              <h3 className='add-emp-section-title'>
                <Mail className='add-emp-section-icon' />
                Contact Information
              </h3>

              <div className='add-emp-field-group'>
                <div className='add-emp-field'>
                  <label className='add-emp-label'>Email *</label>
                  <input
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.email ? "add-emp-input-error" : ""}`}
                    placeholder='email@kaosistores.com'
                  />
                  {errors.email && <span className='add-emp-error'>{errors.email}</span>}
                </div>

                <div className='add-emp-field'>
                  <label className='add-emp-label'>Phone *</label>
                  <input
                    type='tel'
                    name='phone'
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={`add-emp-input ${errors.phone ? "add-emp-input-error" : ""}`}
                    placeholder='+234 81 2345 6789'
                  />
                  {errors.phone && <span className='add-emp-error'>{errors.phone}</span>}
                </div>
              </div>

              {/* Credentials Preview */}
              <div className='add-emp-credentials-preview'>
                <h4 className='add-emp-credentials-title'>Generated Credentials Preview</h4>
                <div className='add-emp-credentials-info'>
                  <p className='add-emp-credentials-note'>Login credentials will be automatically generated based on the employee's name and ID.</p>
                  {formData.name && (
                    <div className='add-emp-preview-fields'>
                      <div className='add-emp-preview-field'>
                        <label>Username:</label>
                        <span>{getInitials(formData.name).toLowerCase().replace(/\s+/g, ".")}.xxxxxxx.xxxx</span>
                      </div>
                      <div className='add-emp-preview-field'>
                        <label>Password:</label>
                        <span>Auto-generated secure password</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className='add-emp-form-actions'>
            <button type='button' className='add-emp-btn-cancel' onClick={handleCloseClick}>
              Cancel
            </button>
            <button disabled={loading} type='submit' className='add-emp-btn-submit'>
              {creatingEmployee ? "Creating..." : "Add Employee"}
            </button>
          </div>
        </form>
      </div>

      {openImageCropper && (
        <ImageCropper
          readImageUrl={employeeImageUrlStage}
          setCroppedImageUrl={setEmployeeImageUrlStage}
          setCroppedImageBolb={setCroppedImageBuffer}
          closeModal={setOpenImageCropper}
          borderRadius={"20%"}
        />
      )}
    </>
  );
};
